<template>
    <div class="form-group radio-form-group clearfix no-focus" :class="[colClass, customErrorClass]">
        <fieldset role="radiogroup" :aria-labelledby="`${vmId} ${errorIds}`" :aria-required="settings.required ? 'true' : 'false'">
            <legend :class="{ dfRequired: settings.required, dfOptional: !settings.required, 'sr-only': effectiveLabelText != effectiveLabel }">
                <span :id="vmId">{{ effectiveLabelText }}</span>
                <HelpIcon :text="settings.helpText" v-if="!isViewOnly" />
                <button class="passthrough icon mr-1" type="button" v-if="showAdminEditControls" @click.prevent="toggleAdminEdit" :class="isAdminEditing ? ['icon-close'] : ['icon-edit']" :aria-label="isAdminEditing ? 'Stop Edit' : 'Edit'" />
            </legend>
            <div v-if="settings.layout == 1">
                <!-- TODO magic numbers -->
                <div class="radio" v-for="[index, item] in (effectiveItems || []).entries()">
                    <label class="form-check-label" :for="isViewOnly ? undefined : vmId + '_Id_' + index">
                        <input type="radio" ref="radioRef" :value="item.value || item.label" :checked.prop="value == null ? defaultValue != null && defaultValue == item.value : value == item.value" v-model="effectiveValue" :name="isViewOnly ? undefined : vmId" :disabled="isViewOnly" :id="vmId + '_Id_' + index" />
                        {{ item.label }}
                        <span class="sr-only" v-if="isNullOrWhitespace(item.label) && !isNullOrWhitespace(item.shortLabel) && !isNullOrWhitespace(item.value)">{{ item.shortLabel }}</span>
                    </label>
                </div>
            </div>
            <div v-if="settings.layout != 1">
                <!-- TODO magic numbers -->
                <label class="radio-inline" v-for="[index, item] in (effectiveItems || []).entries()" :for="isViewOnly ? undefined : vmId + '_Id_' + index">
                    <input type="radio" ref="radioRef" :value="item.value || item.label" :checked.prop="value == null ? defaultValue != null && defaultValue == item.value : value == item.value" v-model="effectiveValue" :name="isViewOnly ? undefined : vmId" :disabled="isViewOnly" :id="vmId + '_Id_' + index" />
                    {{ item.label }}
                    <span class="sr-only" v-if="isNullOrWhitespace(item.label) && !isNullOrWhitespace(item.shortLabel) && !isNullOrWhitespace(item.value)">{{ item.shortLabel }}</span>
                </label>
            </div>

            <ErrorList :data="data" :id="errorId" />
            <Comments :data="data" />
            <AdminSettingsDifferences :data="data" />
        </fieldset>
    </div>
</template>
<script lang="ts">
import { defineComponent, computed, watch, ref } from "vue";
import { useObservable } from "@vueuse/rxjs";
import { map } from "rxjs/operators";
import { props, Props, components, setup } from "./BaseDefMixin.3";
import type RadioGroupDef from "../elements/RadioGroupDef";
import type { RadioGroupSettings } from "@cs-ts/radio-group-settings";
import { isNullOrWhitespace } from "@/lib/whitespaceMethods";
export default defineComponent({
    components: {
        ...components,
        //DatePicker,
    },
    props: props,
    //@ts-ignore
    setup(props: Props<RadioGroupDef, RadioGroupSettings>) {
        const base = setup<RadioGroupDef, RadioGroupSettings>(props);

        const radioRef = ref([] as HTMLInputElement[]);
        base.focus = () => {
            if (radioRef.value.length > 0) {
                radioRef.value[0].focus();
            }
        };

        const effectiveItems = useObservable(props.data.effectiveItems$());
        const defaultValue = useObservable(props.data.defaultValue$().pipe(map(i => (i.length ? i[0] : undefined))));
        const effectiveLabel = useObservable(props.data.effectiveLabel$());
        const effectiveLabelText = useObservable(props.data.effectiveLabelText$());

        const effectiveValue = computed<string | null>({
            get() {
                return (base.value.value ?? defaultValue.value) as string | null;
            },
            set(value) {
                base.value.value = value;
            },
        });
        watch([effectiveItems, effectiveValue], ([newItems, newValue]) => {
            if (newValue != null && newItems != null && newItems?.length > 0 && newItems?.filter(x => x.value == newValue).length == 0) {
                base.value.value = null;
            }
        });

        const saveAdminEdit = async () => {
            throw new Error("TODO");
            //await this.$store.dispatch("page/invokeForm", { type: "AdminEdit", target: /* TODO not unique - ForEach */ this.data.id, data: [this.value] });
            //this.isAdminEditing = false;
        };

        return {
            radioRef,

            effectiveItems,
            defaultValue,
            effectiveLabel,
            effectiveLabelText,
            effectiveValue,

            saveAdminEdit,

            isNullOrWhitespace,

            ...base.expose,
        };
    },
});
</script>
